export default __webpack_public_path__ + "static/media/factory40.5bb73111.jpg";